import {TimePicker} from "@rio-cloud/rio-uikit";
import {useController, useFormContext} from "react-hook-form";
import {RequiredConnectedProps} from "./types.ts";
import {useHasViolation} from "./useHasViolation.ts";
import {FormGroup} from "./FormGroup.tsx";
import {ValidationViolation} from "./ValidationViolation.tsx";

type ConnectedTimePickerProps = RequiredConnectedProps


function isValidTimeFormat(time: string): boolean {
    const timeFormat = /^([0-1]\d|2[0-3]):([0-5]\d)$/;
    return timeFormat.test(time);
}


export const ConnectedTimePicker = ({label, name}: ConnectedTimePickerProps) => {
    const {control} = useFormContext()
    const {field} = useController({name, control})
    const {hasViolation, violations} = useHasViolation(name)

    let value = field.value

    if (value != undefined && !isValidTimeFormat(value)) {
        value = value.slice(0, 5)
    }


    return <FormGroup hasViolation={hasViolation}>
        <label>{label}</label>
        <TimePicker value={value || ""} onChange={field.onChange} showIcon/>
        <ValidationViolation violations={violations} />
    </FormGroup>
}